/**
 * @file: Count.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 数据统计
 */
import request from '@/utils/request'

/**
 * 根据承包商、食堂、年份统计食材全年采购总额(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function countFoodContardeptYearGet(data) {
  return request({
    type: 'biz',
    url: 'count/food/contardept/year/get',
    method: 'post',
    data
  })
}

/**
 * 根据年份统计各食堂采购信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function countFoodInYearDepartGet(data) {
  return request({
    type: 'biz',
    url: 'count/food/in/year/depart/get',
    method: 'post',
    data
  })
}

/**
 * 根据年份统计食材消耗信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function countFoodInYearGet(data) {
  return request({
    type: 'biz',
    url: 'count/food/in/year/get',
    method: 'post',
    data
  })
}

/**
 * 根据年份统计食品类别出库信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function countFoodOutYearGet(data) {
  return request({
    type: 'biz',
    url: 'count/food/out/year/get',
    method: 'post',
    data
  })
}

/**
 * 根据年份统计食品出库月度信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function countFoodOutYearMonthGet(data) {
  return request({
    type: 'biz',
    url: 'count/food/out/year/month/get',
    method: 'post',
    data
  })
}

/**
 * 今日异常统计(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayCount(data) {
  return request({
    type: 'biz',
    url: 'exception/today/count',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Count.js